// 运行时配置

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
export async function getInitialState(): Promise<{ name: string }> {
  return { name: '@umijs/max' };
}

let logo =
  'https://zhgd-morning-meeting.oss-cn-hangzhou.aliyuncs.com/2025/12/15/38dba377d15e43bd90266fec72c98d06.png';

/**
 * 运行时配置
 * @returns
 */
export const layout = (initData: any) => {
  let layout_config = {
    navTheme: 'light',
    fixSiderbar: true,
    layout: 'mix',
    menu: {
      locale: false,
    },
    colorPrimary: '#3A73FD',
    title: '报名系统',
    logo,
    siderWidth: 208,
  };

  return {
    onCollapse: (collapsed: boolean) => {},
    avatarProps: {
      title: '',
    },
    ...layout_config,
  };
};
